import createFetchClient, { type ClientOptions } from 'openapi-fetch'
import {
    createImmutableHook,
    createInfiniteHook,
    createMutateHook,
    createQueryHook,
} from 'swr-openapi'

const cacheKey = 'netdata-cloud-swr' as const

export type NetdataCloudPaths = import('../../types.cloud.d.ts').paths

/**
 * Creates SWR hooks that speak to the Netdata Cloud API.
 * Quick start:
 *   const swr = createCloudSWR({ baseUrl: "https://app.netdata.cloud" });
 *   const { data } = swr.useQuery("/api/v3/spaces");
 */
export default function createCloudSWR(options: ClientOptions = {}): {
    useQuery: ReturnType<typeof createQueryHook<NetdataCloudPaths, any, 'netdata-cloud-swr'>>
    useImmutable: ReturnType<
        typeof createImmutableHook<NetdataCloudPaths, any, 'netdata-cloud-swr'>
    >
    useInfinite: ReturnType<
        typeof createInfiniteHook<NetdataCloudPaths, any, 'netdata-cloud-swr'>
    >
    useMutate: ReturnType<typeof createMutateHook<NetdataCloudPaths, any>>
} {
    const client = createFetchClient<NetdataCloudPaths>(options)

    return {
        useQuery: createQueryHook(client, cacheKey),
        useImmutable: createImmutableHook(client, cacheKey),
        useInfinite: createInfiniteHook(client, cacheKey),
        useMutate: createMutateHook(client, cacheKey, (a, b) => a === b),
    }
}
